const actions = {
    LOADING_START       : 'LOADING_START',
    LOADING_END         : 'LOADING_END',

    FETCH_STUDENT_ACADEMIC_INFO       : 'FETCH_STUDENT_ACADEMIC_INFO',
    FETCH_ACADEMIC_INFO       : 'FETCH_ACADEMIC_INFO',
    FETCH_FILE_SIZE       : 'FETCH_FILE_SIZE',
    FETCH_FILE_LENGTH       : 'FETCH_FILE_LENGTH',

    FETCH_UTILITIES_PERMISSIONS      : 'FETCH_UTILITIES_PERMISSIONS',

    FETCH_UTILITIES_ROLES       : 'FETCH_UTILITIES_ROLES',
    FETCH_UTILITIES_USER        : 'FETCH_UTILITIES_USER',
    FETCH_UTILITIES_SESSIONS    : 'FETCH_UTILITIES_SESSIONS',
    FETCH_UTILITIES_CLASSES     : 'FETCH_UTILITIES_CLASSES',
    FETCH_UTILITIES_SECTIONS     : 'FETCH_UTILITIES_SECTIONS',

    FETCH_UTILITIES_PROMOTED_SESSIONS    : 'FETCH_UTILITIES_PROMOTED_SESSIONS',
    FETCH_UTILITIES_PROMOTED_CLASSES     : 'FETCH_UTILITIES_PROMOTED_CLASSES',
    FETCH_UTILITIES_PROMOTED_SECTIONS     : 'FETCH_UTILITIES_PROMOTED_SECTIONS',

    FETCH_UTILITIES_CLASSROOMS     : 'FETCH_UTILITIES_CLASSROOMS',
    FETCH_UTILITIES_PERIODS     : 'FETCH_UTILITIES_PERIODS',
    FETCH_UTILITIES_SUBJECTS     : 'FETCH_UTILITIES_SUBJECTS',
    FETCH_UTILITIES_ALL_SUBJECTS     : 'FETCH_UTILITIES_ALL_SUBJECTS',
    FETCH_UTILITIES_USERS       : 'FETCH_UTILITIES_USERS',
    FETCH_UTILITIES_ROSTER_USERS       : 'FETCH_UTILITIES_ROSTER_USERS',
    FETCH_UTILITIES_HODS       : 'FETCH_UTILITIES_HODS',
    FETCH_UTILITIES_STUDENTS    : 'FETCH_UTILITIES_STUDENTS',
    FETCH_UTILITIES_COORDINATED_STUDENTS    : 'FETCH_UTILITIES_COORDINATED_STUDENTS',
    FETCH_UTILITIES_ROUTINES    : 'FETCH_UTILITIES_ROUTINES',
    FETCH_UTILITIES_SESSION    : 'FETCH_UTILITIES_SESSION',
    FETCH_UTILITIES_CANDIDATES    : 'FETCH_UTILITIES_CANDIDATES',
    FETCH_UTILITIES_MESSAGE_CANDIDATES    : 'FETCH_UTILITIES_MESSAGE_CANDIDATES',
    FETCH_UTILITIES_COMMENT_CANDIDATES    : 'FETCH_UTILITIES_COMMENT_CANDIDATES',
    RESET_UTILITY_ROUTINES      : 'RESET_UTILITY_ROUTINES',
    FETCH_SECTION_ROUTINES      : 'FETCH_SECTION_ROUTINES',
    FETCH_SECTION_PERIODS      : 'FETCH_SECTION_PERIODS',
    FETCH_UTILITY_CRITERIA      : 'FETCH_UTILITY_CRITERIA',
    FETCH_UTILITY_POSITIONS      : 'FETCH_UTILITY_POSITIONS',
    FETCH_UTILITY_DEPARTMENTS      : 'FETCH_UTILITY_DEPARTMENTS',
    RESET_SECTION_ROUTINES      : 'RESET_SECTION_ROUTINES',
    RESET_PERIODS_ROUTINES      : 'RESET_PERIODS_ROUTINES',
    FETCH_UTILITY_ATTENDANCE_CATEGORIES      : 'FETCH_UTILITY_ATTENDANCE_CATEGORIES',
    FETCH_UTILITIES_PRODUCT_CATEGORIES      : 'FETCH_UTILITIES_PRODUCT_CATEGORIES',
    FETCH_UTILITY_APPLIED_POSITIONS      : 'FETCH_UTILITY_APPLIED_POSITIONS',
    FETCH_UTILITY_EMAILS      : 'FETCH_UTILITY_EMAILS',
    FETCH_UTILITY_CLASS_ROUTINES_FOR_TEACHERS      : 'FETCH_UTILITY_CLASS_ROUTINES_FOR_TEACHERS',
    FETCH_UTILITY_SUBSTITUTE_TEACHERS      : 'FETCH_UTILITY_SUBSTITUTE_TEACHERS',
    FETCH_UTILITY_SALARY_MONTH_DECLARATIONS      : 'FETCH_UTILITY_SALARY_MONTH_DECLARATIONS',
    FETCH_UTILITY_SALARY_INCREMENT_MONTH_DECLARATIONS      : 'FETCH_UTILITY_SALARY_INCREMENT_MONTH_DECLARATIONS',
    FETCH_UTILITY_BULK_DEPARTMENTAL_USERS      : 'FETCH_UTILITY_BULK_DEPARTMENTAL_USERS',
    FETCH_UTILITIES_DEPARTMENTAL_USERS      : 'FETCH_UTILITIES_DEPARTMENTAL_USERS',
    FETCH_UTILITIES_GROUP_EMAILS      : 'FETCH_UTILITIES_GROUP_EMAILS',
    FETCH_UTILITIES_TALENT_CANDIDATES      : 'FETCH_UTILITIES_TALENT_CANDIDATES',
    RESET_UTILITY_FILES      : 'RESET_UTILITY_FILES',
    FETCH_UTILITIES_MAIN_CLUBS      : 'FETCH_UTILITIES_MAIN_CLUBS',
    FETCH_UTILITIES_SUB_CLUBS      : 'FETCH_UTILITIES_SUB_CLUBS',

    LoadingStart: () => {
        return {
            type: actions.LOADING_START,
        };
    },
    LoadingEnd: data => {
        return {
            type: actions.LOADING_END
        };
    },
    fetchStudentAcademicInfoAction: (data) => {
        return {
            type: actions.FETCH_STUDENT_ACADEMIC_INFO,
            data: data
        };
    },
    fetchSalaryMonthDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_SALARY_MONTH_DECLARATIONS,
            data: data
        };
    },
    fetchSalaryIncrementMonthDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_SALARY_INCREMENT_MONTH_DECLARATIONS,
            data: data
        };
    },
    fetchAcademicInfoAction: (data) => {
        return {
            type: actions.FETCH_ACADEMIC_INFO,
            data: data
        };
    },
    fetchRolesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_ROLES,
            data: data
        };
    },
    fetchPermissionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_PERMISSIONS,
            data: data
        };
    },
    fetchEmailsAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_EMAILS,
            data: data
        };
    },
    fetchUserAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_USER,
            data: data
        };
    },
    fetchTeachersAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_SUBSTITUTE_TEACHERS,
            data: data
        };
    },
    fetchSessionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_SESSIONS,
            data: data
        };
    },
    fetchPromotedSessionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_PROMOTED_SESSIONS,
            data: data
        };
    },
    fetchSessionAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_SESSION,
            data: data
        };
    },
    fetchCriteriaAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_CRITERIA,
            data: data
        };
    },
    fetchAttendanceCategoriesAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_ATTENDANCE_CATEGORIES,
            data: data
        };
    },
    fetchPositionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_POSITIONS,
            data: data
        };
    },
    fetchAppliedPositionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_APPLIED_POSITIONS,
            data: data
        };
    },
    fetchDepartmentsAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_DEPARTMENTS,
            data: data
        };
    },
    fetchPromotedClassesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_PROMOTED_CLASSES,
            data: data
        };
    },
    fetchSubClubsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_SUB_CLUBS,
            data: data
        };
    },
    fetchMainClubsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_MAIN_CLUBS,
            data: data
        };
    },
    fetchClassesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_CLASSES,
            data: data
        };
    },
    fetchPromotedSectionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_PROMOTED_SECTIONS,
            data: data
        };
    },
    fetchSectionsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_SECTIONS,
            data: data
        };
    },
    fetchClassRoomsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_CLASSROOMS,
            data: data
        };
    },
    fetchProductCategoriesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_PRODUCT_CATEGORIES,
            data: data
        };
    },
    fetchPeriodsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_PERIODS,
            data: data
        };
    },
    fetchSectionPeriodsAction: (data) => {
        return {
            type: actions.FETCH_SECTION_PERIODS,
            data: data
        };
    },
    fetchSubjectsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_SUBJECTS,
            data: data
        };
    },
    fetchAllSubjectsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_ALL_SUBJECTS,
            data: data
        };
    },
    fetchFileSizeAction: (data) => {
        return {
            type: actions.FETCH_FILE_SIZE,
            data: data
        };
    },
    fetchFileLengthAction: (data) => {
        return {
            type: actions.FETCH_FILE_LENGTH,
            data: data
        };
    },
    fetchUsersAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_USERS,
            data: data
        };
    },
    fetchDepartmentalEmailsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_DEPARTMENTAL_USERS,
            data: data
        };
    },
    fetchGroupEmailsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_GROUP_EMAILS,
            data: data
        };
    },
    fetchBulkDepartmentalUsersAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_BULK_DEPARTMENTAL_USERS,
            data: data
        };
    },
    fetchRosterUsersAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_ROSTER_USERS,
            data: data
        };
    },
    fetchTalentCandidatesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_TALENT_CANDIDATES,
            data: data
        };
    },
    fetchCandidatesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_CANDIDATES,
            data: data
        };
    },
    fetchMessageCandidatesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_MESSAGE_CANDIDATES,
            data: data
        };
    },
    fetchCommentCandidatesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_COMMENT_CANDIDATES,
            data: data
        };
    },
    fetchHodsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_HODS,
            data: data
        };
    },
    fetchStudentsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_STUDENTS,
            data: data
        };
    },
    fetchCoordinatedStudentsAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_COORDINATED_STUDENTS,
            data: data
        };
    },
    fetchRoutinesAction: (data) => {
        return {
            type: actions.FETCH_UTILITIES_ROUTINES,
            data: data
        };
    },
    fetchSectionRoutinesAction: (data) => {
        return {
            type: actions.FETCH_SECTION_ROUTINES,
            data: data
        };
    },
    fetchClassRoutinesForTeacherAction: (data) => {
        return {
            type: actions.FETCH_UTILITY_CLASS_ROUTINES_FOR_TEACHERS,
            data: data
        };
    },
    resetRoutinesFormAction: () => {
        return {
            type: actions.RESET_UTILITY_ROUTINES,
            data: []
        } ;
    },
    resetFilesFormAction: () => {
        return {
            type: actions.RESET_UTILITY_FILES,
            data: []
        } ;
    },
    resetSectionRoutinesFormAction: () => {
        return {
            type: actions.RESET_SECTION_ROUTINES,
            data: []
        } ;
    },
    resetSectionPeriodsFormAction: () => {
        return {
            type: actions.RESET_PERIODS_ROUTINES,
            data: []
        } ;
    },
};

export default actions;
